import React from 'react';
import Nav from 'react-bootstrap/Nav';

const ProfileElement = ({ redirectLink, PageName, icon }) => {
	return (
		<Nav.Item>
			<Nav.Link href={redirectLink}>
				<i className={icon} aria-hidden="true"></i>
				{PageName}
			</Nav.Link>
		</Nav.Item>
	);
};

export default ProfileElement;
